import { render, staticRenderFns } from "./innovate.vue?vue&type=template&id=7d3620a8&"
import script from "./innovate.vue?vue&type=script&lang=js&"
export * from "./innovate.vue?vue&type=script&lang=js&"
import style0 from "./innovate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports